module.exports = __webpack_public_path__ + "static/img/shed.d275591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shed.png
// module id = 54wm
// module chunks = 1